import { MutationTypes } from "@/store/mutations";
import { adminInterface, RootState, state } from "@/store/state";
import { ActionTree } from "vuex";

enum ActionTypes {
  SIGN_IN = "SIGN_IN",
  SIGN_OUT = "SIGN_OUT",
  LOCALE_SET = "LOCALE_SET",
}

const actions: ActionTree<typeof state, RootState> = {
  [ActionTypes.SIGN_IN]({ commit }, admin: adminInterface): void {
    commit(MutationTypes.ADMIN_SET, admin);
  },
  [ActionTypes.SIGN_OUT]({ commit }): void {
    commit(MutationTypes.ADMIN_SET, {});
  },
  [ActionTypes.LOCALE_SET]({ commit }, locale: string): void {
    commit(MutationTypes.SETTING_SET, { locale });
  },
};

type Actions = typeof actions;

export { ActionTypes, actions, Actions };
